import executeRequest, { API_GetConfig, RequestOutput } from 'app/api'
import { Endpoint } from 'app/api/endpoints'


export type API_Authenticate = {
  acceptIncomingReturns?: boolean
  apiKey?: string
  codeCompany?: string
  codeMerchant?: string
  confirmButtonColor?: string
  id?: number
  locale?: string
  merchantSiteUrl?: string
  notes?: string
  personalSection?: string
  personalUrl?: string
  primaryColor?: string
  shopName?: string
  shopNameWhiteLabel?: string
  showPriceOnWidget?: boolean
  showYourLogo?: boolean
  status?: number
  urlLogo?: string
}


type AuthenticateRequestParams = {
  merchantCode: string
}
type AuthenticateResponse = {
  data: API_Authenticate
}
enum AuthenticateReponseError {
}
export async function authenticate(params: AuthenticateRequestParams, config?: API_GetConfig, output?: RequestOutput<AuthenticateResponse, AuthenticateReponseError>) {
  executeRequest({
    endpoint: Endpoint.Autenticate,
    config: config,
    params: params,
    output: output,
  })
}
